import { useEffect } from 'react'

export function useResizeObserver({ callback, ref }) {
  useEffect(() => {
    const element = ref?.current

    if (element) {
      const observer = new ResizeObserver(entries => {
        callback(element, entries[0])
      })

      observer.observe(element)

      return () => {
        observer.disconnect()
      }
    }
  }, [])
}
